import React from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import dashboardBanner from '../assests/img/dashboard-banner.jpg';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from '../Components/sidebar';

function Dashboard() {
    const navigate = useNavigate();
    const [customer, setCustomer] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);

    React.useEffect(() => {
        // Get user credentials from localStorage (set by Login.js)
        const user = localStorage.getItem('user');
        if (!user) {
            setError('No user credentials found. Please login again.');
            setLoading(false);
            navigate('/login');
            return;
        }
        let credentials;
        try {
            credentials = JSON.parse(user);
        } catch (e) {
            setError('Corrupted user credentials. Please login again.');
            setLoading(false);
            localStorage.removeItem('user');
            navigate('/login');
            return;
        }
        if (!credentials.user_id || !credentials.password) {
            setError('Incomplete user credentials. Please login again.');
            setLoading(false);
            localStorage.removeItem('user');
            navigate('/login');
            return;
        }
        fetch(`https://aadikaash.com/backend/wp-json/aadikaash-api/v1/customer_details?user_id=${encodeURIComponent(credentials.user_id)}&password=${encodeURIComponent(credentials.password)}`)
            .then(res => res.json())
            .then(data => {
                setCustomer(data);
                setLoading(false);
            })
            .catch(err => {
                setError('Failed to fetch customer details');
                setLoading(false);
            });
    }, []);

    const handleLogout = () => {
        try {
            localStorage.removeItem('user');
            alert('You have been logged out successfully!');
            // Use setTimeout to ensure navigation after alert
            setTimeout(() => {
                navigate('/login', { replace: true });
            }, 100);
        } catch (error) {
            console.error('Logout failed:', error);
            alert('An error occurred during logout. Please try again.');
        }
    };

    return (
        <div>
            <Header />
            <div className="container dashboard-container">

                  <div className='dashboard-banner'>
                            <img src={dashboardBanner} className='responsive' alt="Dashboard Banner" />
                        </div>
                {/* Debug output for troubleshooting */}
                {error && <pre style={{color:'red'}}>Error: {error}</pre>}
                {!loading && !error && (
                    <details className='d-none' style={{marginBottom:'1em'}}>
                        <summary>Raw API Response (Debug)</summary>
                        <pre>{JSON.stringify(customer, null, 2)}</pre>
                    </details>
                )}
                {loading ? (
                    <div>Loading customer details...</div>
                ) : error ? (
                    <div style={{color: 'red'}}>{error}</div>
                ) : customer && customer.status && customer.data && customer.data.customer_details ? (
                    <>
                        <div className='row'>
                            <div className='welcome-user col-md-12 d-flex justify-content-between align-items-center'>
                                <h1>Welcome {customer.data.customer_details.display_name || 'User'}</h1>
                                <ul>                                 
                                    <li> <button onClick={handleLogout} className="logout-btn btn btn-primary btn-sm">Logout</button></li>
                                </ul>
                            </div>
                        </div>

                      


                        <div className='row'>
                            <div className='col-md-3'>
                                <Sidebar />                                
                            </div>
                            <div className='col-md-9 content-area'>
                                <div className='welcome-page'>
                                    <div className='personal-info-box'>
                                        <h2>Personal Information</h2>
                                        <ul>
                                            <li><label>Membership No.</label> {customer.data.customer_details.membership_no}</li>
                                            <li><label>Person Name</label> {customer.data.customer_details.display_name}</li>
                                            <li><label>Company Name</label> {customer.data.customer_details.company_name}</li>
                                            <li><label>Designation</label> {customer.data.customer_details.designation}</li>
                                            <li><label>Contact</label> {customer.data.customer_details.contact_number}</li>
                                            <li><label>Email Id</label> {customer.data.customer_details.email}</li>
                                            <li><label>Address 1</label> {customer.data.customer_details.address_1}</li>
                                            <li><label>Address 2</label> {customer.data.customer_details.address_2}</li>
                                            <li><label>City</label> {customer.data.customer_details.city}</li>
                                            <li><label>State</label> {customer.data.customer_details.state}</li>
                                            <li><label>Pin code</label> {customer.data.customer_details.pin_code}</li>
                                        </ul>
                                    </div>
                                    <div className='personal-info-box'>
                                        <h2>Booth Information</h2>
                                        <ul>
                                            <li><label>Premium Sections</label> {customer.data.customer_details.premium_sections}</li>
                                            <li><label>Category</label> {customer.data.customer_details.category}</li>
                                            <li><label>Hall</label> {customer.data.customer_details.hall}</li>
                                            <li><label>Booth Zone</label> {customer.data.customer_details.booth_zone}</li>
                                            <li><label>Booth No</label> {customer.data.customer_details.booth_no}</li>
                                            <li><label>Total Booths(S)</label> {customer.data.customer_details.total_boothss}</li>
                                            <li><label>Vendor</label> {customer.data.customer_details.vendor}</li>
                                            <li><label>Manager</label> {customer.data.customer_details.manager}</li>
                                            <li><label>Manager Contact</label> {customer.data.customer_details.manager_contact}</li>
                                        </ul>
                                    </div>
                                    <div className='personal-info-box'>
                                        <h2>Payment Information</h2>
                                        <table className='table table-border'>
                                            <tbody>
                                                <tr><td>Participation Charges Basic</td><td>{customer.data.customer_details.participation_charges_basic}</td></tr>
                                                <tr><td>Participation Charges Premium</td><td>{customer.data.customer_details.participation_charges_premium}</td></tr>
                                                <tr><td>Total Participation Charges</td><td>{customer.data.customer_details.total_participation_charges}</td></tr>
                                                <tr><td>GST</td><td>{customer.data.customer_details.gst}</td></tr>
                                                <tr><td>Total Invoice Amount</td><td>{customer.data.customer_details.total_invoice_amount}</td></tr>
                                                <tr><td>10% Refundable Security Deposit</td><td>{customer.data.customer_details["10%_refundable_security_deposit"]}</td></tr>
                                                <tr><td>Total Amount Payable</td><td>{customer.data.customer_details.total_amount_payable}</td></tr>
                                                <tr><td>Income Tax TDS</td><td>{customer.data.customer_details.income_tax_tds}</td></tr>
                                                <tr><td>Net Amount Payable</td><td>{customer.data.customer_details.net_amount_payable}</td></tr>
                                                <tr><td>Recieved Amount</td><td>{customer.data.customer_details.recieved_amount}</td></tr>
                                                <tr><td>Balance (To Be Paid)</td><td>{customer.data.customer_details.balance_to_be_paid}</td></tr>
                                            </tbody>
                                        </table>
                                        <h3>For any payment discrepancies kindly contact Manish Kumar : - +91 99904 88666</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : null}
            </div>
            <Footer />
        </div>
    );
}

export default Dashboard;
